module.exports = __webpack_public_path__ + "static/media/background-register.e406f3c4.jpg";